const BASE_URL = 'https://ias.psa-ict.co.kr/'

export default {
  data () {
    return {
      dataList: null
    }
  },
  methods: {
    async $post (type, data) {
      const url = BASE_URL + type
      await this.$axios.get(
        url,
        data
      ).then(res => {
        return res
      }).catch(err => {
        return err
      }).finally(() => {
      })
    },
    async $get (type) {
      const url = BASE_URL + type
      await this.$axios.get(
        url
      ).then(res => {
        this.dataList = res.data
      }).catch(err => {
        console.log(err)
      }).finally(() => {
      })
      return this.dataList
    }
  }
}
